 <!-- 我的课程 -->
<template>
  <div class="enroll">
    <div class="head">
      <div class="head-left"> 
        <p class="title">我的课程</p>
      </div>
    </div>
    <div class="nav-list">
      <ul>
        <li class="type" :class="type==''?'cur':''" @click="onCur('')">全部</li>
        <li class="bar divider">|</li>
        <li class="type" :class="type==1?'cur':''" @click="onCur(1)">已学</li>
        <li class="bar divider">|</li>
        <li class="type" :class="type==2?'cur':''" @click="onCur(2)">未学</li>
      </ul>
    </div>
    <div class="enroll-list">
      <ul>
        <li v-for="item,index in courseItem" :key="index" @click="onExamDetails(item.courseId,item.type)">
          <div class="enroll-list-play">
            <img class="enroll-list-img" :src="item.courseImg">
            <img class="enroll-list-icon" src="../../assets/img/icon4.png">
          </div>
          <div class="enroll-list-content">
            <p class="enroll-list-name">{{item.courseName}}</p>
            <p class="enroll-list-time">共{{item.itemCount}}课时<span>|</span>{{item.learnCount}}人学习</p>
            <div style="border-top: 1px solid #ededed; margin-top: 12px;padding: 12px 0 6px;">
              <el-button style="background-color: #ff821c" size="small" type="warning" round>继续学习</el-button>
              <el-button class="buttons" size="small" v-if="item.courseMaterial"  round @click.stop="downloadFile(item.courseMaterial)">资料下载</el-button>
              <!-- <el-button style="background-color: #fffcf9; border: 1px solid #fffcf9;" size="small" type="warning" round v-if="item.type!=1"></el-button> -->
            </div>
          </div>
        </li>
      </ul>
    </div>
    <div class="pagination">
      <el-pagination
        background
        layout="prev, pager, next"
        :total="total"
        :current-page="page"
        :page-size="rows"
        @current-change="currentChange">
      </el-pagination>
    </div>
  </div>
</template>

<script>
import { myCourse } from '../../api/userMG'
export default {
  data() {
    return {
      type:'',
      courseItem:[],
      page:1,
      rows:10,
      total:0,
    }
  },
  created() {
    this.getMyCourse()
  },
  methods:{
    onCur(e){
      this.type = e;
      this.courseItem = []
      this.getMyCourse()
    },
    // 我的报名列表
    getMyCourse(){
      let params = {
        page:this.page,
        rows:this.rows,
        status:this.type
      }
      myCourse(params).then(res => {
        console.log('课程数据',res);
        this.total = res.data.total;
        this.courseItem = res.data.content;
      })
    },
    currentChange(e){
      console.log(e)
      this.page = e;
      this.getMyCourse()
    },
    onExamDetails(id,type){
      this.$router.push({path:'/index/classroomDetails',query: { id: id, type:1,shapeCur:type }})
    },
     // 下载文件
     downloadFile(fileName) {
      let courseMaterial = JSON.parse(fileName);
      console.log(courseMaterial[0].url)
      const loading = this.$loading({
        lock: true,
        text: '下载中',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      window.location.href = courseMaterial[0].url;
      loading.close();
    }
  }
}
</script>

<style scoped>
  .enroll{
    padding: 30px 20px 50px;
    background-image: linear-gradient(bottom,#fff,#fff8f2);
    border: 1px solid #e1e2e6;
    border-radius: 8px;
  }
  .head{
    display: flex;
    justify-content: space-between;
    border-bottom: solid 1px #e6e6e6;
  }
  .head .title{
    font-size: 14px;
    font-weight: 500;
    color: black;
    letter-spacing: 1px;
    margin-bottom: 15px;
  }
  .nav-list{
    margin-top: 20px;
    margin-bottom: 32px;
  }
  .nav-list ul{
    display: flex;
    align-items: center;
  }
  .nav-list ul li{
    font-size: 13px;
    padding: 10px 12px;
    /* margin:  0 10px; */
    cursor: pointer;
  }
  .divider{
    margin:  0 10px;
  }
  .nav-list ul .bar{
    color: #e1e2e6;
  }
  .nav-list ul .type{
    color: black;
  }
  .cur{
    color: #ff821c !important;
    border-bottom: 2px solid #ff821c;
  }
  .enroll-list{
    margin-bottom: 24px;
  }
  .enroll-list ul{
    display: flex;
    align-items: center;
    flex-wrap: wrap;

  }
  .enroll-list ul li{
    width: 31%;
    margin-bottom: 20px;
    margin-right: 20px;
  }
  .enroll-list-play{
    position: relative;
    cursor: pointer;
  }
  .enroll-list-icon{
    position: absolute;
    bottom: 20px;
    left: 20px;
    width: 10px;
    height: 10px;
    padding: 10px;
    border-radius: 50%;
    background-color: rgba(6, 6, 6, 0.3);
  }
  .enroll-list-img{
    width: 100%;
    /* height: 160px; */
    border-top-left-radius: 6px;
    border-top-right-radius: 6px;
  }
  .enroll-list-content{
    border: 1px solid #eaebed;
    border-top: none;
    padding: 10px 12px;
    border-bottom-left-radius: 6px;
    border-bottom-right-radius: 6px;
  }
  .enroll-list-name{
    font-size: 14px;
    color: black;
    margin-bottom: 12px;
  }
  .enroll-list-time{
    font-size: 10px;
    color: #adadad;
  }
  .enroll-list-time span{
    margin: 0 8px;
  }
  .el-button--small.is-round {
    padding: 4px 16px;
  }
  .buttons{
    color: #f35903;
    border:1px solid #f35903;
  }
  .buttons:hover{
    background: none;
  }
  .pagination /deep/ .active{
    background: #ff821c !important;
  }
  .pagination /deep/ .number:hover{
    color: #ff821c !important;
  }
  
</style>


// WEBPACK FOOTER //
// src/views/course/course.vue